import styled from "styled-components";
import * as Type from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import * as Image from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { AvailabilityBadges } from "../../../../../../../common-deprecated/components/aem/lexus/availability-badges/styles/AvailabilityBadgesStyles";

export const Wrapper = styled(Flex.Row)`
    display: flex;
    position: relative;
    padding-bottom: 56px;

    ${AvailabilityBadges} {
        margin-top: ${theme.space[2]}px;
    }
`;

export const Title = styled(Type.H1)`
    margin: 0;
    padding-bottom: 0;
    text-transform: none;
    color: ${theme.colors.midnight};

    ${Type.h2Style};
`;

export const SubTitle = styled.div`
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    letter-spacing: 0.2rem;
    line-height: 2rem;
    color: ${theme.colors.platinumDark};
`;

export const Heading = styled(Flex.Col)``;

export const Actions = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HeroImageWrapper = styled(Flex.Col)`
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @media ${getBreakpoint("up", "md")} {
        z-index: -1;
    }
`;

export const HeroImage = styled(Image.ImageFluid)`
    @media ${getBreakpoint("down", "sm")} {
        margin-left: auto;
        margin-right: auto;
    }

    /* Fix to align the image with the top. All images has some white-space at the top */
    @media ${getBreakpoint("up", "md")} {
        margin-top: -25px;
    }
`;
